module.exports = __webpack_public_path__ + "img/3_Cho_xac_nhan.052dc858.png";